<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Share from '@/js/shareAndGetName'
export default {
  data () {
    return {
      a: ''
    }
  },
  methods: {
    test () {
      const get = {}
      get.boolean = false
      this.WJH.promiseForBoolean(get).then(() => {
      })
      setTimeout(() => {
        get.boolean = true
      }, 5000)
    }
  },
  mounted () {
    // console.log(WJH)
    this.test()
    const share = new Share({ pic: 'http://wx3.sinaimg.cn/mw690/006Zdy2vgy1fxj0dtbn29j302o02nmx1.jpg', url: 'https://sleep.heartide.com/', title: '小睡眠', desc: '给你婴儿般好小睡眠' })
    share.appShare()
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
    font-size: px2html(12px);
  }
</style>

<style lang="scss">
  * {
    padding: 0;
    margin: 0;
  }
  .mt30{margin-top: 30px;}
  .mt50{margin-top: 50px;}
  .center{text-align: center;}
  .right{text-align: right;}
  .fwb{font-weight: bold;}
  .text-main{
    text-align: left;
    padding: px2html(15px);
    h2{margin-bottom: px2html(15px);}
    h3,p{margin-bottom: px2html(10px);}
  }
</style>
